import { render } from "./ExchangeLink.vue?vue&type=template&id=0c0cefce&scoped=true"
import script from "./ExchangeLink.vue?vue&type=script&lang=js"
export * from "./ExchangeLink.vue?vue&type=script&lang=js"

import "./ExchangeLink.vue?vue&type=style&index=0&id=0c0cefce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0cefce"]])

export default __exports__